const pad2 = (value) => String(value).padStart(2, "0");

export const toLocalYmd = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

const startOfDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

export const DATE_RANGE_PRESETS = [
  { value: "", label: "Custom" },
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "this_week", label: "This Week" },
  { value: "last_7_days", label: "Last 7 Days" },
  { value: "last_28_days", label: "Last 28 Days" },
  { value: "last_30_days", label: "Last 30 Days" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "last_90_days", label: "Last 90 Days" },
  { value: "this_year", label: "This Year (Jan 1 – Today)" },
  { value: "last_calendar_year", label: "Last Calendar Year" },
];

export const getPresetDateRange = (preset, referenceDate = new Date()) => {
  const presetKey = String(preset || "").trim();
  if (!presetKey) return null;

  const today = startOfDay(referenceDate);

  switch (presetKey) {
    case "today":
      return { startDate: toLocalYmd(today), endDate: toLocalYmd(today) };
    case "yesterday": {
      const y = addDays(today, -1);
      return { startDate: toLocalYmd(y), endDate: toLocalYmd(y) };
    }
    case "this_week": {
      const day = today.getDay();
      const diffToMonday = day === 0 ? 6 : day - 1;
      const weekStart = addDays(today, -diffToMonday);
      return { startDate: toLocalYmd(weekStart), endDate: toLocalYmd(today) };
    }
    case "last_7_days":
      return {
        startDate: toLocalYmd(addDays(today, -6)),
        endDate: toLocalYmd(today),
      };
    case "last_28_days":
      return {
        startDate: toLocalYmd(addDays(today, -27)),
        endDate: toLocalYmd(today),
      };
    case "last_30_days":
      return {
        startDate: toLocalYmd(addDays(today, -29)),
        endDate: toLocalYmd(today),
      };
    case "this_month": {
      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      return { startDate: toLocalYmd(monthStart), endDate: toLocalYmd(today) };
    }
    case "last_month": {
      const monthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const monthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
      return { startDate: toLocalYmd(monthStart), endDate: toLocalYmd(monthEnd) };
    }
    case "last_90_days":
      return {
        startDate: toLocalYmd(addDays(today, -89)),
        endDate: toLocalYmd(today),
      };
    case "this_year": {
      const yearStart = new Date(today.getFullYear(), 0, 1);
      return { startDate: toLocalYmd(yearStart), endDate: toLocalYmd(today) };
    }
    case "last_calendar_year": {
      const year = today.getFullYear() - 1;
      return {
        startDate: `${year}-01-01`,
        endDate: `${year}-12-31`,
      };
    }
    default:
      return null;
  }
};

export const detectPresetFromRange = (startDate, endDate) => {
  if (!startDate || !endDate) return "";
  const match = DATE_RANGE_PRESETS.find((preset) => {
    if (!preset.value) return false;
    const range = getPresetDateRange(preset.value);
    return range?.startDate === startDate && range?.endDate === endDate;
  });
  return match?.value || "";
};
